import {Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2} from '@angular/core';
import {ConfirmationService, MessageService, PrimeNGConfig} from "primeng/api";
import {MsgTemplateData} from "@app/_components/msg-template/msg-template-data";
import {OrderService} from "@app/_components/order";
import {AlertService, ConstantService, UserService} from "@app/_services";
import {ReservationService} from "@app/_components/reservation";
import {FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {Location} from "@angular/common";
import { first } from 'rxjs';
import {ActivatedRoute, Router} from "@angular/router";
import {LostFoundService} from "@app/_components/lost-found/lost-found.service";
import {PropertyService} from "@app/_components/property";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig} from "@angular/material/dialog";
import * as moment from "moment";
import {ReservationCreateComponent} from "@app/_components/reservation/components/reservation-create/reservation-create.component";
import { HttpClient } from "@angular/common/http";
import {OwnerStmtService} from "@app/_components/owner-statements/owner-stmt.service";
import {OwnerStmtExpComponent} from '@app/_components/owner-stmt-exp/owner-stmt-exp/owner-stmt-exp.component';
import { StatementsComponent } from '@app/_components/owner-stmt-view/statements/statements.component';
import { OwnerStmt } from '@app/_components/owner-stmt/owner-stmt';
import { ExpenseComponent } from '@app/_components/expense/expense/expense.component';
import { ExpenseService } from '@app/_components/expense/expense.service';
import { OwnerStatementMailService } from '@app/_components/owner-statements/owner-statement-mail.service';
import { NotesChatConfig } from '@app/_components/_shared/notes-chat/notes-chat.component';

@Component({
    selector: 'app-statement',
    templateUrl: './statement.component.html',
    styleUrls: ['./statement.component.scss'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class StatementComponent implements OnInit {
  reservation: any;
  referralSources: any[];
  orderStatuses: any[];
  salesManList: any[];
  lostFounds: any[]=[];
  paymentTypes: any[];
  paymentReceivedTypes: any;

  msgVOListUpdated: boolean;
  showCreateReservationPopUp = false;
  isReservationLoaded = false;
  numAdults: any[];
  properties: any[] = [];
  reservations: any[] = [];
  msgTemplateData: MsgTemplateData;
  grandTotals: number;
  totalTaxes: number;
  totalAmounts: number;
  paymentRecieve: number;
  paymentSources: any[]=[];
  applyToList: any[]=[];
  paymentDepositTypes: any[]=[];
  invoiceDetailTypes: any[]=[];
  paymentList: any[]=[];
  visible = false;
  countries: any;
  cardExpiryMonths: any[];
  cardExpiryYears: any[];
  orderInvoiceDetailId: any;
  errorList: any[]=[];
  showValidationErrors = false;
  errorMessages: string;
  salesmen: any[]=[];
  selectedEmailType: any;
  cancelReservationIds: any[]=[];
  orderDetailList: any[]=[];
  orderInvoiceDetailList: any[]=[];
  searchName: any = null;
  isLoadPaymentList = false;
  isUserHaveSalesMen1Role = false;
  isUserHaveSalesMen2Role = false;
  shortTermRentalId;
  ownerStmtId: any;
  ownerStmt: any = {ownerStmtId : 0};
  ownerStmtOjb: any; // For summary calculation from findStmtById API
  form: UntypedFormGroup;
  summaryPaymentToOwner: number = 0;
  summaryEndingBalance: number = 0;
  summaryGuestNights: number = 0;
  summaryOwnerNights: number = 0;
  summaryOwnerGuestNights: number = 0;
  summaryMaintenanceNights: number = 0;
  summaryGuestNightsOccupancyRate: number = 0;
  summaryOwnerNightsOccupancyRate: number = 0;
  summaryOwnerGuestNightsOccupancyRate: number = 0;
  summaryMaintenanceNightsOccupancyRate: number = 0;

  /** Set from dialog data — true when the dashboard has critical blockers. */
  publishBlocked = false;
  criticalBlockers = 0;

  constructor(
    private http: HttpClient,
    private primengConfig: PrimeNGConfig,
    private orderService: OrderService,
    private ownerStmtService: OwnerStmtService,
    private userService: UserService,
    private alertService: AlertService,
    private reservationService: ReservationService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private location1: Location,
    private activatedRoute: ActivatedRoute,
    private lostFoundService: LostFoundService,
    private propertyService: PropertyService,
    private constantService: ConstantService,
    private dialog: MatDialog,
    private router: Router,
    private renderer: Renderer2,
    private expenseService: ExpenseService,
    private ownerStatementMailService: OwnerStatementMailService,
    @Inject(MAT_DIALOG_DATA) data: any) {
    this.formTitle = data.title;
      this.publishBlocked = !!data.publishBlocked;
      this.criticalBlockers = data.criticalBlockers || 0;
      this.shortTermRentalId = data.shortTermRentalId;
      this.reservation = data.reservation;
      this.statuses = orderService.statuses;
      this.ownerStmtId = this.reservation?.ownerStmtId;
    this.referralSources = this.reservationService.referralSources;
    this.orderStatuses = this.reservationService.orderStatuses;
    this.salesManList = this.reservationService.salesManList;
    this.paymentTypes = this.reservationService.paymentTypes;
    this.paymentReceivedTypes = orderService.paymentReceivedTypes;
    this.paymentDepositTypes = orderService.paymentDepositTypes;
    this.invoiceDetailTypes = orderService.invoiceDetailTypes;
    this.numAdults = this.reservationService.numAdults;
    this.countries = this.constantService.countries;
    this.cardExpiryMonths = this.reservationService.cardExpiryMonths;
    this.cardExpiryYears = this.reservationService.cardExpiryYears;
    this.renderer.addClass(document.body, 'custom-body-class');
  }

  @Input() order: any;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  orderId: number;

  // forms
  form1: UntypedFormGroup;
  form2: UntypedFormGroup;
  form3: UntypedFormGroup;
  form4: UntypedFormGroup;
  formLoading = false;
  mailComposeLoading = false;
  formAlert: String;
  formTitle: String;

  // Summary loading state
  summaryLoading = false;
  expenseLoading = false;

  // Summary calculation properties
  summaryStartingBalance: number = 0;
  summaryRents: number = 0;
  summaryPaidNights: number = 0;
  summaryOccupancyRate: number = 0;
  summaryTaxRevenue: number = 0;
  summaryMaintenanceCredit: number = 0;
  summaryHousekeepingCredit: number = 0;
  summarySubtotalCredits: number = 0;
  summaryMaintenanceDebit: number = 0;
  summaryHousekeepingDebit: number = 0;
  summaryManagementDebit: number = 0;
  summaryTaxPaidDebit: number = 0;
  summarySubtotalDebits: number = 0;
  summaryNetProceeds: number = 0;

  summaryRowsConfig: any = [
    { label: 'Starting Balance', totalKey: 'summaryStartingBalance', stmtSummeryField: 'startingBalance' },
    { label: 'Rents', totalKey: 'summaryRents', stmtSummeryField: 'rentalRevenue' },
    { label: 'Tax', totalKey: 'summaryTaxRevenue', stmtSummeryField: 'taxRevenue', taxBreakdown: 'revenue' },
    { label: 'Housekeeping Credit', totalKey: 'summaryHousekeepingCredit', stmtSummeryField: 'housekeepingCreditTotal' },
    { label: 'Maintenance Credit', totalKey: 'summaryMaintenanceCredit', stmtSummeryField: 'maintenanceCreditTotal' },
    { label: 'Total Revenue', totalKey: 'summarySubtotalCredits', stmtSummeryField: 'totalRevenueWithExpenseCredit', rowClass: 'summary-total-row' },
    { label: 'Housekeeping', totalKey: 'summaryHousekeepingDebit', stmtSummeryField: 'housekeepingPaidByOwnerTotalWithExpenseCredit' },
    { label: 'Maintenance', totalKey: 'summaryMaintenanceDebit', stmtSummeryField: 'maintenancePaidByOwnerTotalWithExpenseCredit' },
    { label: 'Management', totalKey: 'summaryManagementDebit', stmtSummeryField: 'mgntExpense' },
    { label: 'Tax Paid On Your Behalf', totalKey: 'summaryTaxPaidDebit', stmtSummeryField: 'taxExpense', taxBreakdown: 'expense' },
    { label: 'Total Expenses', totalKey: 'summarySubtotalDebits', stmtSummeryField: 'totalExpenseWithExpenseCredit', rowClass: 'summary-total-row' },
    { label: 'Net Proceeds', totalKey: 'summaryNetProceeds', stmtSummeryField: 'totalNetProceed', rowClass: 'summary-net-proceeds-row' },
    { label: 'Payment To Owner', totalKey: 'summaryPaymentToOwner', stmtSummeryField: 'paymentToOwner' },
    { label: 'Ending Balance', totalKey: 'summaryEndingBalance', stmtSummeryField: 'endingBalance' },
  ];

  statuses: any;
  status: any;

  validationMessages = {
    'orderId': [],
    'status': [],
    'ccPremiumPct': [],
    referralSourceId:[],
    creditSaleTo2:[],
    creditSaleTo:[],
    lostFoundId:[],
    changeLog:[],

  };
  validationMessages4 = {
    amount: [{ type: 'required', message: 'Required' }],
    type: [{ type: 'required', message: 'Required' }],
  };

  validationMessages2 = {
    shortTermRentalId: [{ type: 'required', message: 'Required' }],
    emailAddress: [{ type: 'required', message: 'Required' },
      { type: 'email', message: 'Not a valid Email' }],
    referralSourceId: [{ type: 'required', message: 'Required' }],
    numAdults: [{ type: 'required', message: 'Required' }],
    numChildren: [{ type: 'required', message: 'Required' }],
    checkOutDate: [{ type: 'required', message: 'Required' }],
    checkInDate: [{ type: 'required', message: 'Required' }],
    firstName: [{ type: 'required', message: 'Required' }],
    lastName: [{ type: 'required', message: 'Required' }],
  };

  ownerNotes: any;
  originalOwnerNotes: any = '';
  showOwnerNotesButtons = false;
  updatingOwnerNotes = false;
  showTaxBreakdownDialog = false;
  taxBreakdownType: 'revenue' | 'expense' = 'revenue';
  taxBreakdownData: any[] = [];
  taxBreakdownTitle: string = '';
  stmtStatuses: any[] = [
    { value: 0, label: 'Default' },
    { value: 1, label: 'Draft' },
    { value: 2, label: 'NeedAttention' },
    { value: 3, label: 'ReadyForReview1' },
    { value: 4, label: 'ReadyForReview2' },
    { value: 5, label: 'ReadyForReview3' },
    { value: 6, label: 'Approved' },
    { value: 7, label: 'Published' }
  ];

  notesChatConfig: NotesChatConfig = {
    title: 'Homeowner Notes',
    maxWidth: '100%',
    maxHeight: '600px',
    customClass: '',
    fieldsPosition: 'top',
    showFilters: true,
    showSortOptions: true,
    fillParent: false,
    sortByDate: 'desc',
    allowEdit: true,
    allowDelete: false,
    allowAdd: true,
    emptyNotesText: 'No notes added',
    placeholder: 'Enter remarks',
    theme: 'default',
    maxNoteLength: 500,
    editButtonText: 'Edit Note',
    deleteButtonText: 'Delete Note',
    cancelButtonText: 'Cancel',
    noteTypes: [
      { value: 1, name: 'General', color: '#DCDCDC' },
      { value: 2, name: 'Action Item', color: '#ffcccc' },
      { value: 4, name: 'Meeting Notes', color: '#ade061' },
      { value: 5, name: 'Status Update', color: '#FFFF99' }
    ],
    statusOptions: [
      { value: 0, name: 'Open', color: '#D3D3D3' },
      { value: 1, name: 'Complete', color: '#90EE90' },
      { value: 2, name: 'Proposed', color: '#FFE599' },
      { value: 3, name: 'On Hold', color: '#ADD8E6' },
      { value: 4, name: 'Cancelled', color: '#F4A6A6' },
      { value: 5, name: 'In Progress', color: '#FFA500' }
    ]
  };

  validationMessages3 = {
    paymentConfirmId: [],
    paymentProcessDate: [{ type: 'required', message: 'Required' }],
    paymentType: [{ type: 'required', message: 'Required' }],
    paymentProcessAmount: [{ type: 'required', message: 'Required' }],
    paymentSourceAccountIdentifier: [],
    paymentTransactionConfirmNumber: [],
    paymentProceedsDepositedToAccountIdentifier: [],
    paymentGatewayProvider: [],
    billingName: [{ type: 'required', message: 'Required' }],
    billingStreetAddress: [{ type: 'required', message: 'Required' }],
    billingCity: [{ type: 'required', message: 'Required' }],
    billingState: [{ type: 'required', message: 'Required' }],
    billingPostalCode: [{ type: 'required', message: 'Required' }],
    billingCountry: [{ type: 'required', message: 'Required' }],

  };

  months = [
    "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER", "YTD"
  ];

  tableRows = [
    { label: "Starting Balance", field: "startingBalance" },
    { label: "Rents", field: "rentalRevenue" },
    // { label: "Paid Nights", field: "paidNights" },
    // { label: "Guest Nights", field: "guestNight" },
    // { label: "Owner Nights", field: "ownerNights" },
    // { label: "Owner Guest Nights", field: "ownerGuestNights" },
    // { label: "Maintenance Nights", field: "maintenanceNights" },
    // { label: "Occupancy Rate", field: "occupancyRate" },
    { label: "Tax", field: "taxRevenue" },
    { label: "Hskp Credit", field: "housekeepingCreditTotal" },
    { label: "Maint Credit", field: "maintenanceCreditTotal" },
    { label: "Total Revenue", field: "totalRevenueWithExpenseCredit" },
    { label: "Maintenance", field: "maintenancePaidByOwnerTotalWithExpenseCredit" },
    { label: "Housekeeping", field: "housekeepingPaidByOwnerTotalWithExpenseCredit" },
    { label: "Management", field: "mgntExpense" },
    { label: "Tax Paid", field: "taxExpense" },
    { label: "Total Expenses", field: "totalExpenseWithExpenseCredit" },
    { label: "Net Proceeds", field: "totalNetProceed" },
    { label: "Payment To Owner", field: "paymentToOwner" },
    { label: "Ending Balance", field: "endingBalance" }
  ];

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.paymentList = [];
    this.formBuildForStatus();
    this.formBuild();
    this.formBuildForAddNewReservation();
    this.formBuildForInvoiceOrderDetail();
    this.formBuildForInvoiceOrderDetailUpdateAndDelete();
    this.fetchProperties();

    if(this.reservation == null && this.reservation == undefined){
      this.activatedRoute.params.subscribe(params =>
      {
        this.orderId = params.orderId;
        this.ownerStmtId = params?.orderId ? Number(params.orderId) : 0;
        this.ownerStmt.ownerStmtId = this.ownerStmtId; // (+) converts string 'id' to a number
        this.formTitle = "Edit Statement";
      });
      if(this.orderId != null && this.orderId != undefined){
        this.findOrderById();
      }
    }else{
      this.orderId = this.reservation?.ownerStmtId;
      if(this.orderId == undefined && this.orderId == null){
        this.orderId = this.reservation?.order?.ownerStmtId;
      }
      if(this.orderId != null && this.orderId != undefined){
        this.ownerStmtId = this.orderId;
        this.ownerStmt.ownerStmtId = this.ownerStmtId;
        this.findOrderById();
      }
    }
  }

  openTaxBreakdownDialog(type: 'revenue' | 'expense'): void {
    this.taxBreakdownType = type;
    
    if (type === 'revenue') {
      this.taxBreakdownData = this.ownerStmtOjb?.stmtSummery?.taxRevenueList || [];
      this.taxBreakdownTitle = 'Tax Revenue Breakdown';
    } else {
      this.taxBreakdownData = this.ownerStmtOjb?.stmtSummery?.taxRevenuePaidOnYourBehalfList || [];
      this.taxBreakdownTitle = 'Tax Expense Breakdown';
    }
    
    if (this.taxBreakdownData.length > 0) {
      this.showTaxBreakdownDialog = true;
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'No Data',
        detail: `No ${type === 'revenue' ? 'tax revenue' : 'tax expense'} data available.`,
        life: 3000
      });
    }
  }

  getTotalTaxAmount(): number {
    return this.taxBreakdownData.reduce((total, tax) => total + (tax.amount || 0), 0);
  }
  
  findOrderById() {
    this.formLoading = true;
    this.ownerStmtService.findById(this.orderId)
      .pipe(first())
      .subscribe(
        res => {
    // this.http.get<any>('assets/reservation-report-response.json').subscribe(res => {
          console.log('findReservationById: ' + JSON.stringify(res));
          // this.order = res.data.order;
          this.order = res.data.ownerStmt;
          this.form.patchValue({
            stmtStatus: this.order?.stmtStatus,
          });
          this.form1.patchValue(this.order);
          // this.fetchSalesmen();
        /*  this.form1.patchValue({
            referralSourceId: this.order?.referralSourceId,
            status: this.order?.status,
          });*/

          // this.order?.reservations.forEach(reservation => {
          // 	if (reservation?.reservationStatus == "OX") {
          // 		this.cancelReservationIds.push(reservation?.reservationId);
          // 	}
          // });

          // this.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
          // 	if (!this.cancelReservationIds.includes(orderDetail?.reservationId)) {
          // 		this.orderDetailList.push(orderDetail);
          // 	}
          // });
          // this.order.orderInvoice.orderDetails = this.orderDetailList;

          // this.order?.orderInvoice?.orderInvoiceDetails.forEach(orderInvoiceDetail => {
          // 	if (!this.cancelReservationIds.includes(orderInvoiceDetail?.reservationId)) {
          // 		this.orderInvoiceDetailList.push(orderInvoiceDetail);
          // 	}
          // });
          // this.order.orderInvoice.orderInvoiceDetails = this.orderInvoiceDetailList;

          this.grandTotals = this.grandTotal();
          this.totalTaxes = this.totalTax();
          this.totalAmounts = this.totalAmount();
          this.paymentRecieve = this.outStandingBalance();
          // Fetch summary data using findStmtById API (same as StatementsComponent)
          this.fetchSummaryData();
          this.ownerNotes = this.order?.ownerNotes || '';
          this.originalOwnerNotes = this.order?.ownerNotes || '';
          this.showOwnerNotesButtons = false;
          this.order?.paymentSources?.forEach(paymentSource => {
            let data1 = paymentSource?.paymentType+" "+paymentSource?.creditCardType+" "+paymentSource?.billingName+" "+paymentSource?.creditCardNumber+" "+paymentSource?.creditCardExpirationMonth+"/"+paymentSource?.creditCardExpirationYear;
            let data = { paymentSource: paymentSource, value: paymentSource?.paymentSourceId, name: data1.toString()};
            this.paymentSources.push(data);
          });

          this.order?.orderInvoice?.orderInvoiceDetails.forEach(orderInvoiceDetail => {
            if(orderInvoiceDetail?.type == 2 || orderInvoiceDetail?.type == 4 || orderInvoiceDetail?.type == 5 || orderInvoiceDetail?.type == 6 || orderInvoiceDetail?.type == 7 || orderInvoiceDetail?.type == 8 ||  orderInvoiceDetail?.type == 9){
              if(orderInvoiceDetail?.reservationId == null){
                orderInvoiceDetail.reservationId = this.order.reservations[0].reservationId;
              }
              this.paymentList.push(orderInvoiceDetail);
              this.isLoadPaymentList = true;
            }
          });


          // this.mapReservation(this.reservation);
        },
        err => {
          console.log('error In findReservationById is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, life: 3000 });
        },
        () => { this.formLoading = false; });
  }



  onFormDelete() {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Id# ' + this.orderId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete()
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log('property-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.orderService.add(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.order = res.data.order;
            this.doAdd.emit(this.order);
          },
          (err: any) => {
            console.log('order-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log('order: ' + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.orderService.update(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.order = res.data.order;
            // this.doUpdate.emit(this.order);
          },
          (err: any) => {
            console.log('property-update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.orderService.delete(this.order.orderId)
        .subscribe(
          (res: any) => {
            console.log('order-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.doDelete.emit(this.order);
          },
          (err: any) => {
            console.log('order-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      this.alertService.error(error);
    }
  }

  /*********
   * Lazy Load All Data
   *
   */
  getLostFound() {
    this.lostFoundService.findByReservationId(this.reservation.reservationId)
      .pipe(first())
      .subscribe(
        res => {
          console.log('findReservationById: ' + JSON.stringify(res));
          this.lostFounds = res.data.lostFounds;
        },
        err => {
          console.log('error In findReservationById is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, life: 3000 });
        },
        () => { this.formLoading = false; });
  }

  formBuildForStatus() {
    this.form = this.formBuilder.group({
      stmtStatus: []
    });
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      orderId: [this.orderId],
      status: [],
      referralSourceId: [],
      creditSaleTo2: [],
      creditSaleTo: [],
      lostFoundId: [],
      changeLog:[],
      orderInvoice: this.formBuilder.group({
        ccPremiumPct: [],
      }),
    });
  }

  formBuildForInvoiceOrderDetail(){
    this.form3 = this.formBuilder.group({
      orderInvoiceId: [],
      reservationId: [],
      orderInvoiceDetailId: [],
      amount: ['',Validators.required],
      type: ['',Validators.required],
      description: [],
      effectiveDate: [],
      enteredByUserId: [],
      privateNotes: [],
      paymentConfirm: this.formBuilder.group({
        paymentConfirmId: [],
        paymentProcessDate: [],
        billingName: [],
        paymentSourceAccountIdentifier: [],
        paymentType: [],
        paymentTransactionConfirmNumber: [],
        paymentProceedsDepositedToAccountIdentifier: [],
      }),
    });
  }

  formBuildForInvoiceOrderDetailUpdateAndDelete(){
    this.form4 = this.formBuilder.group({
      orderInvoiceId: [],
      reservationId: [],
      orderInvoiceDetailId: [],
      enteredByUserId: [],
      amount: [],
      type: [],
      description: [],
      effectiveDate: [],
      privateNotes: [],
      paymentConfirm: this.formBuilder.group({
        paymentConfirmId: [],
        paymentProcessDate: ['',Validators.required],
        paymentType: ['',Validators.required],
        paymentProcessAmount: ['',Validators.required],
        paymentSourceAccountIdentifier: [],
        paymentTransactionConfirmNumber: [],
        paymentProceedsDepositedToAccountIdentifier: [],
        paymentGatewayProvider: [],
        billingName: [],
        billingStreetAddress: [],
        billingCity: [],
        billingState: [],
        billingPostalCode: [],
        billingCountry: ['US'],
        paymentSource: this.formBuilder.group({
          payorUserId:[],
          paymentSourceId: [],
          paymentType: [],
          billingName: [],
          billingStreetAddress: [],
          billingCity: [],
          billingState: [],
          billingPostalCode: [],
          billingCountry: ['US'],
          achBankName: [],
          achBankAccountNumber: [],
          achRoutingNumber: [],
          achAccountType: [],
          achCheckNumber: [],
          achMicrData: [],
          achBranchSortCode: [],
          creditCardType: [],
          creditCardNumber: [],
          creditCardExpirationMonth: [],
          creditCardExpirationYear: [],
          creditCardSecurityCode: [],
        })

      })
    });
  }

  formBuildForAddNewReservation() {
    this.form2 = this.formBuilder.group({
      shortTermRentalId: ['', Validators.required],
      referralSourceId: ['', Validators.required],
      numAdults: [2, Validators.required],
      numChildren: [0, Validators.required],
      checkOutDate: ['', Validators.required],
      checkInDate: ['', Validators.required],
      guestProfile: this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        emailAddress: ['', Validators.compose([Validators.required, Validators.email])],
        guestCompanions: new UntypedFormArray([]),
      }),
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.order.orderDate = moment(this.order.orderDate).toDate();
  }

  gotoReservation() {
    this.location1.go('/owner-statements');
    this.router.navigate(['owner-statements']);
  }

  closePopUp(){
    this.location1.go('/owner-statements');
  }

  //
  getPaymentTypeName(paymentAttempt: any) {
    if (paymentAttempt?.paymentType != null && paymentAttempt?.paymentType != undefined) {
      const status = this.paymentTypes.find((e: any) => e.value == paymentAttempt?.paymentType);
      return status.name;
    }
    else {
      return '';
    }
  }
  sendGuestComm(stage: number) {
    this.formLoading = true;
    this.reservationService.sendGuestCommunication(this.reservations[0]?.reservationId, stage)
      .pipe(first())
      .subscribe(
        res => {
          this.msgVOListUpdated = !this.msgVOListUpdated;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
          console.log('findReservationById: ' + JSON.stringify(res));
        },
        err => {
          // Do NOT reset formLoading on error — a 504 means the communication may have been sent.
          // Keep button disabled to prevent duplicate guest communications.
          console.log('error sending guest communication: ' + JSON.stringify(err));
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Communication may have been sent. Please refresh before retrying: ' + err.message, life: 3000 });
        },
        () => { this.formLoading = false; });
  }

  grandTotal(){
    let total = 0
    if(this.order?.orderInvoice?.orderDetails.length > 0){
      this.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
        total += orderDetail?.total
      });
    }
    return total;
  }

  outStandingBalance(){
    let paymentRecieved = 0
    if(this.order?.orderInvoice?.orderInvoiceDetails.length > 0){
      this.order?.orderInvoice?.orderInvoiceDetails.forEach(orderInvoiceDetail => {
        if(orderInvoiceDetail?.type == 2){
          paymentRecieved += orderInvoiceDetail?.amount
        }
      });
    }
    return paymentRecieved;
  }

  totalTax(){
    let total = 0
    if(this.order?.orderInvoice?.orderDetails.length > 0){
      this.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
        total += orderDetail?.tax
      });
    }
    return total;
  }
  totalAmount(){
    let total = 0;
    if(this.order?.orderInvoice?.orderDetails.length > 0){
      this.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
        total += orderDetail?.subTotal
      });
    }
    return total;
  }

  getPropertyCode(orderDetail: any) {
    if (orderDetail?.reservationId) {
      const status = this.reservations.find((e: any) => e.reservationId == orderDetail.reservationId);
      return status.shortTermRental.propertyCode;
    }
    else {
      return '';
    }
  }

  openCreateReservationPopUp() {
    const dialogConfig = new MatDialogConfig();

    const data = {
      orderId: this.order?.orderId,
      referralSourceId: this.order?.referralSourceId,
      numAdults: this.reservations[0]?.numAdults,
      numChildren: this.reservations[0]?.numChildren,
      checkOutDate: moment.utc(this.reservations[0]?.checkOutDate).format('MM/DD/YYYY'),
      checkInDate: moment.utc(this.reservations[0]?.checkInDate).format('MM/DD/YYYY'),
      guestProfile: {
        firstName: this.reservations[0]?.guestProfile?.firstName,
        lastName: this.reservations[0]?.guestProfile?.lastName,
        emailAddress: this.reservations[0]?.guestProfile?.emailAddress,
      },
    };
    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "40vw";
    dialogConfig.width = "20vw";
    dialogConfig.disableClose = true;
    // dialogConfig.maxHeight = "50vw";
    // dialogConfig.height = "95vh";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      showCloseButton: true,
      reservation: data,
      openNewTab: false
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ReservationCreateComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        // this.reloadPage();
        this.ngOnInit()

        // close the dialogBox
        dialogRef.close();
      });
  }

  reloadPage() {
    window.location.reload();
  }

  addOrderInvoiceDetail(payment: any) {
    console.log('findReservationById: ' + JSON.stringify(this.form3.value));
    // stop here if form is invalid
    this.form3.markAllAsTouched();
    if (this.form3.invalid) {
      return;
    }
    if(this.form3.value.reservationId == null && payment.reservationId == null){
      this.form3.value.reservationId = this.order.reservations[0].reservationId;
    }

    const data = {
      orderInvoiceId: this.order?.orderInvoice?.orderInvoiceId,
      reservationId: this.form3.value.reservationId != null ? this.form3.value.reservationId : payment.reservationId,
      amount: -this.form3.value.amount,
      type: this.form3.value.type,
      description: this.form3.value.description,
      effectiveDate: this.form3.value.effectiveDate,
      enteredByUserId: 0,
      privateNotes: this.form3.value.privateNotes,
      paymentConfirm: {
        paymentProcessDate: this.form3.value.paymentConfirm.paymentProcessDate,
        paymentProcessAmount: -this.form3.value.amount,
        billingName: this.form3.value.paymentConfirm.billingName,
        paymentSourceAccountIdentifier: this.form3.value.paymentConfirm.paymentSourceAccountIdentifier,
        paymentType: this.form3.value.paymentConfirm.paymentType,
        paymentTransactionConfirmNumber: this.form3.value.paymentConfirm.paymentTransactionConfirmNumber,
        paymentProceedsDepositedToAccountIdentifier: this.form3.value.paymentConfirm.paymentProceedsDepositedToAccountIdentifier,
      },
    };

    try {
      this.formLoading = true;
      this.orderService.orderInvoiceDetailAdd(data)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            // const paymentData = {
            // 	reservationId: this.order.reservations[0].reservationId,
            // 	orderInvoiceDetailId: res.data.orderInvoiceDetail?.orderInvoiceDetailId,
            // 	orderInvoiceId: res.data.orderInvoiceDetail?.orderInvoiceId,
            // 	enteredByUserId: res.data.orderInvoiceDetail?.enteredByUserId,
            // 	effectiveDate: res.data.orderInvoiceDetail?.effectiveDate != null ? moment(res.data.orderInvoiceDetail?.effectiveDate).toDate() : null,
            // 	paymentProcessDate: res.data.orderInvoiceDetail?.paymentConfirm?.paymentProcessDate != null ? moment(res.data.orderInvoiceDetail?.paymentConfirm?.paymentProcessDate).toDate() : null,
            // 	amount: res.data.orderInvoiceDetail?.amount,
            // 	paymentType: res.data.orderInvoiceDetail?.paymentConfirm?.paymentType,
            // 	billingName: res.data.orderInvoiceDetail?.paymentConfirm?.billingName,
            // 	paymentSourceAccountIdentifier: res.data.orderInvoiceDetail?.paymentConfirm?.paymentSourceAccountIdentifier,
            // 	paymentTransactionConfirmNumber: res.data.orderInvoiceDetail?.paymentConfirm?.paymentTransactionConfirmNumber,
            // 	paymentProceedsDepositedToAccountIdentifier: res.data.orderInvoiceDetail?.paymentConfirm?.paymentProceedsDepositedToAccountIdentifier,
            // 	type: res.data.orderInvoiceDetail?.type,
            // 	description: res.data.orderInvoiceDetail?.description,
            // 	privateNotes: res.data.orderInvoiceDetail?.privateNotes,
            // }
            this.reloadPage();
            // this.paymentList.push(res.data.orderInvoiceDetail);
            // this.form3.reset();
            this.formLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: "Payment added successfully" });
          },
          (err: any) => {
            // Do NOT reset formLoading on error — a 504 means the backend may
            // have already saved the payment. Keep button disabled to block re-submit.
            console.log('order-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { });
    } catch (error) {
      this.formLoading = false;
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  fetchProperties() {
    try {
      this.propertyService.findAllSummaryWithStatusActiveAndSuspended()
        .subscribe(
          res => {
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.properties = res.data.properties;
          },
          err => {
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  fetchSalesmen() {
    try {
      this.userService.getSalesmen()
        .subscribe(
          res => {
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.salesmen = res.data.salesmen;
            this.salesmen.forEach((value, index) => {
              if(this.order?.creditSaleTo != null && this.order?.creditSaleTo != undefined && this.order?.creditSaleTo != ""){
                if(this.salesmen[index].userId == this.order?.creditSaleTo?.userId){
                  this.isUserHaveSalesMen1Role = true;
                }
              }
              if(this.order?.creditSaleTo2 != null && this.order?.creditSaleTo2 != undefined && this.order?.creditSaleTo2 != ""){
                if(this.salesmen[index].userId == this.order?.creditSaleTo2?.userId){
                  this.isUserHaveSalesMen2Role = true;
                }
              }
              this.salesmen[index].fullName = value.firstName +" "+ value.lastName;
            });
            if(!this.isUserHaveSalesMen1Role && this.order?.creditSaleTo != null && this.order?.creditSaleTo != undefined && this.order?.creditSaleTo != ""){
              this.order.creditSaleTo.fullName = this.order?.creditSaleTo?.firstName +" "+ this.order?.creditSaleTo?.lastName;
              this.salesmen.push(this.order.creditSaleTo);
            }

            if(!this.isUserHaveSalesMen2Role && this.order?.creditSaleTo2 != null && this.order?.creditSaleTo2 != undefined && this.order?.creditSaleTo2 != ""){
              this.order.creditSaleTo2.fullName = this.order?.creditSaleTo2?.firstName +" "+ this.order?.creditSaleTo2?.lastName;
              this.salesmen.push(this.order.creditSaleTo2);
            }

            this.form1.patchValue({
              creditSaleTo: this.order?.creditSaleTo?.userId,
              creditSaleTo2: this.order?.creditSaleTo2?.userId,
            });
          },
          err => {
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  getReservationlist(reservationUpdated: any){
    if(this.reservations.length > 0){
      var reservationExists = false;
      this.reservations.forEach((reservationOld, index) => {
        if(reservationOld.reservationId == reservationUpdated.reservationId){
          reservationExists = true;
          this.reservations[index] = reservationUpdated;
        }
      });
      if(reservationExists == false){
        this.reservations.push(reservationUpdated);
      }
    }else{
      this.reservations.push(reservationUpdated);
    }
    if(this.reservations.length == this.order.reservations.length){
      this.reservations.forEach( (reservation) => {
        const applyToData = {
          value: reservation?.reservationId,
          name: reservation?.shortTermRental?.propertyCode
        }
        this.applyToList.push(applyToData);
      });
    }
    this.setTemplateData(this.reservations[0]);
    this.isReservationLoaded = true;
  }

  setTemplateData(res: any) {
    this.msgTemplateData = new MsgTemplateData();
    let firstName = res?.guestProfile?.firstName ? res?.guestProfile?.firstName : '';
    let lastName = res?.guestProfile?.lastName ? res?.guestProfile?.lastName : '';
    this.msgTemplateData.fullName =  firstName + ' ' + lastName;
    this.msgTemplateData.firstName = firstName;
    this.msgTemplateData.reservationId = res?.reservationId;
    this.msgTemplateData.resortName = res?.shortTermRental?.propertyCode;
    this.msgTemplateData.adrDevelopmentName = res?.shortTermRental?.developmentName;
    this.msgTemplateData.confirmationNumber = res?.reservationConfId;
    this.msgTemplateData.emailAddress = res?.guestProfile?.emailAddress;
    this.msgTemplateData.mobilePhone = res?.guestProfile?.mobilePhone;
    this.msgTemplateData.checkInDateTime = res?.checkInDate;
    this.msgTemplateData.checkOutDateTime = res?.checkOutDate;
    return this.msgTemplateData;
  }

  selectEmailContract() {
    const data = {
      "reservationId": this.reservations[0].reservationId,
      "orderId": this.order.orderId
    }

    this.orderService.emailContract(data)
      .subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => { this.formLoading = false; });
  }

  selectEmailInvoice() {
    const data = {
      "reservationId": this.reservations[0].reservationId,
      "orderId": this.order.orderId
    }

    this.orderService.emailInvoice(data)
      .subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => { this.formLoading = false; });
  }

  selectEmailCheckInDetails() {
    const data = {
      "reservationId": this.reservations[0].reservationId,
      "orderId": this.order.orderId
    }
    this.orderService.emailCheckInDetails(data)
      .subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => { this.formLoading = false; });
  }

  selectEmailRentalCarConfirmation() {
    const data = {
      "reservationId": this.reservations[0].reservationId,
      "orderId": this.order.orderId
    }
    this.orderService.emailRentalCarConfirmation(data)
      .subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => { this.formLoading = false; });
  }

  sendReservationEmail(){
    this.onChange(this.selectedEmailType);
  }

  onChange(event: any){
    if(event === "contract"){
      this.selectEmailContract();
    }
    if(event === "invoice"){
      this.selectEmailInvoice();
    }
    if(event === "checkInDetails"){
      this.selectEmailCheckInDetails();
    }
    if(event === "rentalCar"){
      this.selectEmailRentalCarConfirmation();
    }
  }

  onChangeSetEmailType(event: any){
    if(event === "contract"){
      this.selectedEmailType = "contract";
    }
    if(event === "invoice"){
      this.selectedEmailType = "invoice";
    }
    if(event === "checkInDetails"){
      this.selectedEmailType = "checkInDetails";
    }
    if(event === "rentalCar"){
      this.selectedEmailType = "rentalCar";
    }
  }

  getApplyToList(reservationId: any) {
    if (reservationId) {
      const status = this.applyToList.find((e: any) => e.value == reservationId);
      return status.name;
    }
    else {
      return '';
    }
  }

  onOwnerNotesChange() {
    if (this.ownerNotes !== this.originalOwnerNotes) {
      this.showOwnerNotesButtons = true;
    } else {
      this.showOwnerNotesButtons = false;
    }
  }

  cancelOwnerNotesUpdate() {
    this.ownerNotes = this.originalOwnerNotes;
    this.showOwnerNotesButtons = false;
  }

  updateOwnerNotes() {
    if (!this.ownerStmtId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Owner statement ID is missing.',
        life: 3000
      });
      return;
    }

    this.updatingOwnerNotes = true;

    const updateData = {
      ownerStmtId: this.ownerStmtId,
      ownerNotes: this.ownerNotes || ''
    };

    this.ownerStmtService.updateOwnerNotes(updateData).subscribe(
      (res: any) => {
        this.updatingOwnerNotes = false;
        this.originalOwnerNotes = this.ownerNotes;
        this.showOwnerNotesButtons = false;

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Owner notes updated successfully.',
          life: 3000
        });
      },
      (err: any) => {
        this.updatingOwnerNotes = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err.error?.message || 'Failed to update owner notes. Please try again.',
          life: 3000
        });
      }
    );
  }

  getPaymentReceivedType(paymentType: any) {
    if (paymentType) {
      const status = this.paymentReceivedTypes.find((e: any) => e.value == paymentType);
      return status.name;
    }
    else {
      return '';
    }
  }

  getPaymentDepositType(paymentProceedsDepositedToAccountIdentifier: any) {
    if (paymentProceedsDepositedToAccountIdentifier) {
      const status = this.paymentDepositTypes.find((e: any) => e.value == paymentProceedsDepositedToAccountIdentifier);
      return status.name;
    }
    else {
      return '';
    }
  }

  getTypeName(type: any) {
    if (type) {
      const status = this.invoiceDetailTypes.find((e: any) => e.value == type);
      return status.name;
    }
    else {
      return '';
    }
  }

  isVoidAllowed(payment: any){
    return payment && payment.paymentConfirm && payment.paymentConfirm.paymentType && payment.paymentConfirm.paymentType === 'CR'
      && payment.type && payment.type === 2;

  }

  voidPayment(payment: any) {
    try {
      this.formLoading = true;
      // set contract data into form contract

      let paymentData = {
        voidOrderInvoiceDetailId : payment.orderInvoiceDetailId
      };

      this.confirmationService.confirm({
        message: 'Are you sure you want to void this transactions? ',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          try {
            // stop here if form is invalid
            this.formLoading = true;
            this.reservationService.makeVoidPaymentByAdmin(paymentData)
              .subscribe(
                (res: any) => {
                  if (res.data?.reservationSummary?.reservationApiList[0]?.status === 'INVALID') {
                    this.confirmationService.confirm({
                      header: 'Payment Error',
                      message: res.data?.reservationSummary?.reservationApiList[0]?.errors[0]?.message,
                      icon: 'fa fa-exclamation-triangle',
                      rejectVisible: false,
                      acceptLabel: 'Close',
                      accept: () => {
                        this.formLoading = false;
                        this.doRefreshOrder();
                      }
                    });
                  }else{
                    this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Transaction voided successfully. for orderInvoiceDetailId#' + payment.orderInvoiceDetailId, life: 3000});
                    this.formLoading = false;
                    this.doRefreshOrder();
                  }
                },
                (err: any) => {
                },
                () => {
                  this.formLoading = false;
                });
          } catch (error) {
            console.log('Form Invalid: ' + JSON.stringify(error));
            this.alertService.error(error);
            this.formLoading = false;
          }
        },
        reject: () => {
          this.messageService.add({severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000});
          this.formLoading = false;
        }
      });

    } catch (error) {
      this.formLoading = false;
    }
  }

  openPopUpPaymentSource(payment: any){
    this.form4.reset();
    console.log('property-add post: ' + JSON.stringify(this.form4.value));
    console.log('property-add post: ' + JSON.stringify(payment.paymentConfirm));
    payment.paymentConfirm.paymentProcessDate = moment(payment.paymentConfirm.paymentProcessDate).toDate();
    payment.effectiveDate = moment(payment.effectiveDate).toDate();
    this.orderInvoiceDetailId = payment.orderInvoiceDetailId;

    this.form4.patchValue(payment);
    this.visible = true;
  }

  updateInvoiceOrder(){
    try {
      // stop here if form is invalid
      this.form4.markAllAsTouched();
      console.log('property-add post: ' + JSON.stringify(this.form4.value));
      console.log('property-add post: ' + JSON.stringify(this.form4.value.paymentConfirm));
      console.log('property-add post: ' + JSON.stringify(this.form4.value.paymentConfirm.paymentSource));
      // if (this.form4.invalid) {
      // 	return;
      // }
      if ((this.form4.value.paymentConfirm.paymentProcessAmount == null && this.form4.value.paymentConfirm.paymentProcessAmount == undefined && this.form4.value.paymentConfirm.paymentProcessAmount == "")) {
        return;
      }
      if ((this.form4.value.paymentConfirm.paymentType == null && this.form4.value.paymentConfirm.paymentType == undefined && this.form4.value.paymentConfirm.paymentType == "")) {
        return;
      }
      if ((this.form4.value.paymentConfirm.paymentProcessDate == null && this.form4.value.paymentConfirm.paymentProcessDate == undefined && this.form4.value.paymentConfirm.paymentProcessDate == "")) {
        return;
      }
      console.log('property-add post: ' + JSON.stringify(this.form4.value));
      this.form4.value.paymentConfirm.paymentSource.payorUserId =this.form4.value.enteredByUserId;
      this.form4.value.amount = -this.form4.value.paymentConfirm.paymentProcessAmount;
      this.formLoading = true;

      this.orderService.updateOrderInvoiceDetail(this.form4.value)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.reloadPage();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: "Update successfully" });
            this.visible = false;
          },
          (err: any) => {
            this.formLoading = false;
            console.log('order-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {  });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  closeDialog(){
    this.visible = false;
  }

  sendEmailPaymentRecieveToGuest(){
    try {
      const data = {
        "reservationId": this.reservations[0].reservationId,
        "orderId": this.order.orderId,
        "orderInvoiceDetailId" : this.orderInvoiceDetailId
      }
      this.formLoading = true;
      this.orderService.sendEmailPaymentRecieveToGuest(data)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
          },
          (err: any) => {
            this.formLoading = false;
            console.log('order-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {  });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  deleteOrderInvoiceDetailConfirmation() {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Order Invoice Detail Id# ' + this.orderInvoiceDetailId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteOrderInvoiceDetail()
        this.visible = false;
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }

  deleteOrderInvoiceDetail() {
    try {
      this.formLoading = true;
      this.orderService.deleteOrderInvoiceDetail(this.orderInvoiceDetailId)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
            this.reloadPage();
            console.log('order-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: "Delete order invoice successfully" });
            this.paymentList.forEach((payment, index) => {
              if(payment.orderInvoiceDetailId == this.orderInvoiceDetailId){
                this.paymentList.splice(index, 1);
              }
            });
          },
          (err: any) => {
            this.formLoading = false;
            console.log('order-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { });
    } catch (error) {
      this.alertService.error(error);
    }
  }

  filterText(text: string) {
    if (text) {
      text = text
        .replace('<br>', '\r')
        .replace('/&lt;br/&gt;', '\r')
        .replace('</p>', '')
        .replace('<br>', '\r')
        .replace(/(?:\r\n|\r|\n|\\r|\\n)/gi, '<br>');
      return text;
    }
    return '';
  }

  updateReservations(){
    this.showValidationErrors = false;
    this.errorMessages = "";
    this.errorList = [];
    this.reservations.forEach((reservation, index) => {
      if(reservation.reservationDirty){
        this.showValidationErrors = false;
        this.formLoading = true;
        this.reservationService.updateGuestInfo(reservation)
          .pipe(first())
          .subscribe(
            res => {
              this.reservations[index].reservationDirty = false;
              this.errorList.push("Reservation "+(index + 1)+" is updated successfully");
              if(this.reservations[index]?.guestProfile?.firstName == null || this.reservations[index]?.guestProfile?.firstName == ""){
                this.errorList.push("  ==> FirstName is required");
              }
              if(this.reservations[index]?.guestProfile?.lastName == null || this.reservations[index]?.guestProfile?.lastName == ""){
                this.errorList.push("  ==> LastName is required");
              }
              if(this.reservations[index]?.guestProfile?.emailAddress == null || this.reservations[index]?.guestProfile?.emailAddress == ""){
                this.errorList.push("  ==> Email Address is required");
              }
              this.errorMessages = "";
              this.showValidationErrors = true;
              for (let i = 0; i < this.errorList.length; i++) {
                this.errorMessages += this.errorList[i] + "\n";
              }
              this.formLoading = false;
              console.log('findReservationById: ' + JSON.stringify(res));
              // this.alertService.success(this.errorMessages, true);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: this.errorMessages, life: 3000 });
              // this.reservation = res.data.reservation;
              // this.findReservationById();
            },
            err => {
              this.formLoading = false;
              this.errorList.push("Reservation "+(index + 1)+" is updated fail");
              // this.alertService.error(err, true);
              console.log('error reservation update: ' + JSON.stringify(err));
              this.formLoading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation update fail: ' + err, life: 3000 });
            },
            () => {  });
      }else{
        this.errorList.push("Reservation "+(index + 1)+" is don't have any changes");
      }
      if(this.reservations[index]?.guestProfile?.firstName == null || this.reservations[index]?.guestProfile?.firstName == ""){
        this.errorList.push("  ==> FirstName is required");
      }
      if(this.reservations[index]?.guestProfile?.lastName == null || this.reservations[index]?.guestProfile?.lastName == ""){
        this.errorList.push("  ==> LastName is required");
      }
      if(this.reservations[index]?.guestProfile?.emailAddress == null || this.reservations[index]?.guestProfile?.emailAddress == ""){
        this.errorList.push("  ==> Email Address is required");
      }
    });
    for (let i = 0; i < this.errorList.length; i++) {
      this.errorMessages += this.errorList[i] + "\n";
    }
    var dialogResUpdateInfo = false;
    this.reservations.forEach((reservation, index) => {
      if(reservation.reservationDirty){
        dialogResUpdateInfo = true;
      }
    });
    if(dialogResUpdateInfo == false){
      this.showValidationErrors = true;
    }
  }

  refreshStatement() {
    if (!this.orderId) {
      this.messageService.add({ 
        severity: 'warn', 
        summary: 'Warning', 
        detail: 'No statement ID available to refresh', 
        life: 3000 
      });
      return;
    }

    this.paymentList = [];
    this.paymentSources = [];

    this.findOrderById();

    this.messageService.add({ 
      severity: 'info', 
      summary: 'Refreshing', 
      detail: 'Statement data is being refreshed...', 
      life: 2000 
    });
  }

  updateOrder() {
    const orderSummaryData = {
      orderId: this.orderId,
      status: this.form1.value.status,
      referralSourceId: this.form1.value.referralSourceId,
      creditSaleTo2: {
        userId : this.form1.value.creditSaleTo2
      },
      creditSaleTo: {
        userId : this.form1.value.creditSaleTo
      },
      orderInvoice: {
        ccPremiumPct: this.form1.value.orderInvoice.ccPremiumPct,
      },
    }

    this.formLoading = true;
    this.orderService.updateOrderSummery(orderSummaryData)
      .subscribe(
        res => {
          this.formLoading = false;
          console.log('findReservationById: ' + JSON.stringify(res));
          this.messageService.add({ severity: 'success', summary: 'Success', detail: "Order update successfully", life: 3000 });
        },
        err => {
          this.formLoading = false;
          // this.alertService.error(err, true);
          console.log('error reservation update: ' + JSON.stringify(err));
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation update fail: ' + err, life: 3000 });
        },
        () => {  });
  }

  doRefreshOrder(){
    this.ngOnInit();
  }

  isPayment(orderInvoiceDetail: any){
    if(orderInvoiceDetail){
      return orderInvoiceDetail?.type == 2 ||	orderInvoiceDetail?.type == 4 || orderInvoiceDetail?.type == 8 ||  orderInvoiceDetail?.type == 9;
    }
    return false;
  }

  redirectToReservations(){
    if(this.searchName != null && this.searchName != undefined && this.searchName != ""){
      // const data ={
      // 	searchName: this.searchName
      // }
      // const formData = JSON.parse(JSON.stringify(data));

      this.router.navigate(['/owner-statements'], { queryParams: { searchName: this.searchName} });
      this.doUpdate.emit(this.searchName);
    }
  }

  ngOnDestroy(): void {
    // Remove the class from body on component destroy
    this.renderer.removeClass(document.body, 'custom-body-class');
  }

  regenerateStatement() {
    this.formLoading = true;
    this.ownerStmtService.regenerateStatement(this.order?.ownerStmtId).subscribe(res => {
      this.doRefreshOrder();
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Statement regenerated successfully' });
    },(err: any) => {
      this.formLoading = false;
      console.log('regenerateStatement FAIL: ' + JSON.stringify(err));
      this.messageService.add({ severity: 'error', summary: 'Error', detail: err, life: 3000 });
    },() => {
      this.formLoading = false;
    });
  }

   reGenerateOrderObj() {
    this.regenerateStatement();
  }

  openExpenseEdit(expense: any) {
    try {
      this.expenseLoading = true;
      this.expenseService.findById(expense?.expenseId)
        .subscribe(
          (res: any) => {
            console.log('expense-findById SUCCESS: ' + JSON.stringify(res));
            this.expenseLoading = false;
            this.onOpenExpenseFormEdit(res.data.expense);
          },
          (err: any) => {
            console.log('expense-findById FAIL: ' + JSON.stringify(err));
            this.expenseLoading = false;
            this.alertService.error(err);
          },
          () => { });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.expenseLoading = false;
      this.alertService.error(error);
    }
  }

  onOpenExpenseFormEdit(expense: any) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = '60vw';
    dialogConfig.width = '40vw';

    // pass data
    dialogConfig.data = {
      expense: expense,
      title: 'Edit Expense'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ExpenseComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        // refresh the order to show updated expense
        this.findOrderById();
        // close the dialogBox
        dialogRef.close();
      });

    dialogRef.componentInstance.doDelete.subscribe(
      data => {
        console.log('Dialog output:', data);
        // refresh the order to show updated expense
        this.findOrderById();
        // close the dialogBox
        dialogRef.close();
      });
  }

  onOpenFormAdd() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add OwnerStmtExp',
      ownerStmtId: this.orderId
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(OwnerStmtExpComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
       // this.addOwnerStmtExpCB(data);

        // close the dialogBox
        dialogRef.close();
      });
  }

  
		//View Statement

	/*********
		* Edit Button
		*
		*/
		onOpenFormEdit() {

			const dialogConfig = new MatDialogConfig();
	
			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.maxWidth = '1500px'
			dialogConfig.maxHeight = '90vh'
			dialogConfig.height = '90vh'
			dialogConfig.width = '100vw'
      dialogConfig.panelClass = 'my-class'
      
      this.location1.go('/owner-stmt-preview/' + this.ownerStmtId);
			
			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
        ownerStmt: this.ownerStmt,
        isDialogMode: true,
				title: 'Edit OwnerStmt'
			};
	
			// open the popup and get a reference to it called dialogRef
			let dialogRef = this.dialog.open(StatementsComponent, dialogConfig );
			
	
			// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
			dialogRef.componentInstance.doUpdate.subscribe(
				data => {
					console.log('Dialog output:', data);
	
					// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//	this.updateOwnerStmtCB(data);
	
					// close the dialogBox
					dialogRef.close();
				});
	
			dialogRef.componentInstance.doDelete.subscribe(
				data => {
					console.log('Dialog output:', data);
	
					// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
					//this.deleteOwnerStmtCB(data);
	
					// close the dialogBox
					dialogRef.close();
        });
      
      dialogRef.afterClosed().subscribe(() => {
        this.location1.go('/owner-statement/' + this.ownerStmtId);
      });
		}

    /*********
	 * Delete Button
	 *
	 */
    changeStatus(value: any) {
    this.form.get('stmtStatus')?.setValue(value);
		console.log('changeStatus: ' + JSON.stringify(value));
		if (value === 7 && this.publishBlocked) {
			this.confirmationService.confirm({
				message: `There are ${this.criticalBlockers} critical blocker(s) on the dashboard (expense blockers, unlocked reservations, or missing ledger rows) that should be resolved before publishing. Are you sure you want to publish anyway?`,
				header: 'Publishing With Blockers',
				icon: 'pi pi-exclamation-triangle',
				acceptLabel: 'Publish Anyway',
				rejectLabel: 'Cancel',
				accept: () => { this.updateOwnerStmtStatus(value); },
				reject: () => {
					this.form.patchValue({ stmtStatus: this.order?.stmtStatus });
					this.messageService.add({ severity: 'info', summary: 'Publish Cancelled', detail: 'Resolve the dashboard blockers before publishing.', life: 5000 });
				}
			});
			return;
		}
		this.confirmationService.confirm({
			message: 'Are you sure you want to update Id# ' + this.ownerStmtId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.updateOwnerStmtStatus(value);
			},
			reject: () => {
        this.form.patchValue({
          stmtStatus: this.order?.stmtStatus,
        });
				this.messageService.add({ severity: 'info', summary: 'Updated', detail: 'Update canceled.', life: 3000 });
			}
		});
	}

  updateOwnerStmtStatus(status: any) {
		try {
			this.formLoading = true;
			this.ownerStmtService.updateOwnerStmtStatus(this.ownerStmtId, status)
				.subscribe(
					(res: any) => {
            this.formLoading = false;
            this.findOrderById();
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Successfully Update Status', life: 3000 });
					},
					(err: any) => {
            this.formLoading = false;
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Update Failed', detail: 'Update status fails '+JSON.stringify(err), life: 3000 });
					},
					() => {  });
		} catch (error) {
      this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
  }
  
  trackByExp(index: number, exp: any) {
    return exp.ownerStmtExpId;
  }

  // Year to Date calculation methods
  getMonthlyValue(data: any[], monthIndex: number, field: string): number {
    if (!data || !Array.isArray(data)) return 0;
    return data
      .filter(item => {
        const date = item[field] ? new Date(item[field]) : null;
        return date && date.getMonth() === monthIndex;
      })
      .reduce((sum, item) => sum + (item.amount || item.total || item.subTotal || 0), 0);
  }

  getMonthlyRevenue(monthIndex: number): number {
    if (!this.order?.ownerStmtRezs) return 0;
    return this.order.ownerStmtRezs
      .filter(rez => {
        const date = rez.createDate ? new Date(rez.createDate) : null;
        return date && date.getMonth() === monthIndex;
      })
      .reduce((sum, rez) => {
        const rezTotal = rez.rezTotal || rez.total || 0;
        return sum + rezTotal;
      }, 0);
  }

  getMonthlyTaxRevenue(monthIndex: number): number {
    if (!this.order?.ownerStmtRezs) return 0;
    return this.order.ownerStmtRezs
      .filter(rez => {
        const date = rez.createDate ? new Date(rez.createDate) : null;
        return date && date.getMonth() === monthIndex;
      })
      .reduce((sum, rez) => {
        const tax = rez.rezTax || rez.tax || 0;
        return sum + tax;
      }, 0);
  }

  getMonthlyTaxExpense(monthIndex: number): number {
    if (!this.order?.ownerStmtRezs) return 0;
    return this.order.ownerStmtRezs
      .filter(rez => {
        const date = rez.createDate ? new Date(rez.createDate) : null;
        return date && date.getMonth() === monthIndex;
      })
      .reduce((sum, rez) => {
        const tax = rez.rezTax || rez.tax || 0;
        return sum - tax; // Negative for expense
      }, 0);
  }

  getMonthlyMgmtExpense(monthIndex: number): number {
    if (!this.order?.ownerStmtExps) return 0;
    return this.order.ownerStmtExps
      .filter(exp => {
        const date = exp.expenseDate ? new Date(exp.expenseDate) : null;
        return date && date.getMonth() === monthIndex && exp.name?.toLowerCase().includes('mgmt');
      })
      .reduce((sum, exp) => {
        const total = exp.expTotal || exp.total || 0;
        return sum - total; // Negative for expense
      }, 0);
  }

  getMonthlyMaintExpense(monthIndex: number): number {
    if (!this.order?.ownerStmtExps) return 0;
    return this.order.ownerStmtExps
      .filter(exp => {
        const date = exp.expenseDate ? new Date(exp.expenseDate) : null;
        return date && date.getMonth() === monthIndex && 
               (exp.name?.toLowerCase().includes('maint') || exp.name?.toLowerCase().includes('hskp'));
      })
      .reduce((sum, exp) => {
        const total = exp.expTotal || exp.total || 0;
        return sum - total; // Negative for expense
      }, 0);
  }

  getTotalKbmPaid(): number {
    if (!this.order?.ownerStmtExps) return 0;
    return this.order.ownerStmtExps.reduce((sum, exp) => {
      return sum + (exp.amountPaidByKBM || 0);
    }, 0);
  }

  getTotalOwnerPaid(): number {
    if (!this.order?.ownerStmtExps) return 0;
    return this.order.ownerStmtExps.reduce((sum, exp) => {
      return sum + (exp.amountPaidByOwner || 0);
    }, 0);
  }

  getYTDValue(monthIndex: number, getter: (m: number) => number): number {
    let total = 0;
    for (let i = 0; i <= monthIndex; i++) {
      total += getter(i);
    }
    return total;
  }

  getMonthValue(monthIndex: number, type: string): number {
    switch(type) {
      case 'startingBalance': return 0;
      case 'rentalRevenue': return this.getMonthlyRevenue(monthIndex);
      case 'taxRevenue': return this.getMonthlyTaxRevenue(monthIndex);
      case 'totalRevenue': return this.getMonthlyRevenue(monthIndex) + this.getMonthlyTaxRevenue(monthIndex);
      case 'taxExpense': return this.getMonthlyTaxExpense(monthIndex);
      case 'mgmtExpense': return this.getMonthlyMgmtExpense(monthIndex);
      case 'maintExpense': return this.getMonthlyMaintExpense(monthIndex);
      case 'totalExpenses': 
        return this.getMonthlyTaxExpense(monthIndex) + 
               this.getMonthlyMgmtExpense(monthIndex) + 
               this.getMonthlyMaintExpense(monthIndex);
      case 'netProceeds':
        const revenue = this.getMonthlyRevenue(monthIndex) + this.getMonthlyTaxRevenue(monthIndex);
        const expenses = this.getMonthlyTaxExpense(monthIndex) + 
                        this.getMonthlyMgmtExpense(monthIndex) + 
                        this.getMonthlyMaintExpense(monthIndex);
        return revenue + expenses; // expenses are already negative
      case 'paymentToOwner':
        const rev = this.getMonthlyRevenue(monthIndex) + this.getMonthlyTaxRevenue(monthIndex);
        const exp = this.getMonthlyTaxExpense(monthIndex) + 
                   this.getMonthlyMgmtExpense(monthIndex) + 
                   this.getMonthlyMaintExpense(monthIndex);
        return rev + exp;
      case 'endingBalance': return 0;
      default: return 0;
    }
  }

  getYTDTotal(type: string): number {
    let total = 0;
    for (let i = 0; i < 12; i++) {
      total += this.getMonthValue(i, type);
    }
    return total;
  }

  // Fetch summary data using findStmtById API (same as StatementsComponent)
  fetchSummaryData(): void {
    try {
      this.summaryLoading = true;
      this.ownerStmtService.findStmtById(this.orderId)
        .pipe(first())
        .subscribe(
          res => {
            console.log('findStmtById Data: ' + JSON.stringify(res));
            this.ownerStmtOjb = res.data.ownerStmt;
            this.calculateSummary();
            this.summaryLoading = false;
          },
          err => {
            console.log('findStmtById FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
            this.summaryLoading = false;
          },
          () => { 
            this.summaryLoading = false;
          });
    } catch (error) {
      console.log('fetchSummaryData Error: ' + JSON.stringify(error));
      this.alertService.error(error);
      this.summaryLoading = false;
    }
  }

  calculateSummary(): void {
    this.summaryStartingBalance = this.ownerStmtOjb?.stmtSummery?.startingBalance || 0;
    this.summaryRents = this.ownerStmtOjb?.stmtSummery?.rentalRevenue || 0;
    this.summaryPaidNights = this.ownerStmtOjb?.stmtSummery?.paidNights || 0;
    this.summaryGuestNights = this.ownerStmtOjb?.guestNight || 0;
    this.summaryOwnerNights = this.ownerStmtOjb?.ownerNights || 0;
    this.summaryOwnerGuestNights = this.ownerStmtOjb?.ownerGuestNights || 0;
    this.summaryMaintenanceNights = this.ownerStmtOjb?.maintenanceNights || 0;
    this.summaryOccupancyRate = this.ownerStmtOjb?.occupancyRate || 0;
    this.summaryGuestNightsOccupancyRate = this.ownerStmtOjb?.guestNightOccupancyRate || 0;
    this.summaryOwnerNightsOccupancyRate = this.ownerStmtOjb?.ownerNightsOccupancyRate || 0;
    this.summaryOwnerGuestNightsOccupancyRate = this.ownerStmtOjb?.ownerGuestNightsOccupancyRate || 0;
    this.summaryMaintenanceNightsOccupancyRate = this.ownerStmtOjb?.maintenanceNightsOccupancyRate || 0;
    this.summaryTaxRevenue = this.ownerStmtOjb?.stmtSummery?.taxRevenue || 0;
    this.summaryMaintenanceCredit = this.ownerStmtOjb?.stmtSummery?.maintenanceCreditTotal || 0;
    this.summaryHousekeepingCredit = this.ownerStmtOjb?.stmtSummery?.housekeepingCreditTotal || 0;
    this.summarySubtotalCredits = this.ownerStmtOjb?.stmtSummery?.totalRevenueWithExpenseCredit || 0;
    this.summaryMaintenanceDebit = this.ownerStmtOjb?.stmtSummery?.maintenancePaidByOwnerTotalWithExpenseCredit || 0;
    this.summaryHousekeepingDebit = this.ownerStmtOjb?.stmtSummery?.housekeepingPaidByOwnerTotalWithExpenseCredit || 0;
    this.summaryManagementDebit = this.ownerStmtOjb?.stmtSummery?.mgntExpense || 0;
    this.summaryTaxPaidDebit = this.ownerStmtOjb?.stmtSummery?.taxExpense || 0;
    this.summarySubtotalDebits = this.ownerStmtOjb?.stmtSummery?.totalExpenseWithExpenseCredit || 0;
    this.summaryNetProceeds = this.ownerStmtOjb?.stmtSummery?.totalNetProceed || 0;
    this.summaryPaymentToOwner = this.ownerStmtOjb?.stmtSummery?.paymentToOwner || 0;
    this.summaryEndingBalance = this.ownerStmtOjb?.stmtSummery?.endingBalance || 0;
  }

  getValueByMonth(month: string, field: string): number {
    const data = this.ownerStmtOjb?.yearlySummary.stmtSummeryAPIs.find(
      (stmt) => stmt.month.toUpperCase() === month
    );
    return data ? data[field] || 0 : 0;
  }

  get ownerStmtPdfSplitByOwner(): any[] | null {
    // const list = this.ownerStmtOjb?.ownerStmtPdfSplitByOwner;
    // return Array.isArray(list) && list.length > 0 ? list : null;
    return null;
  }

  getSplitOwnerHeading(splitItem: any): string {
    const p = splitItem?.ownerProfileStmtSummery;
    if (!p) return '';
    const name = [p.firstName, p.middleName, p.lastName, p.suffix].filter(Boolean).join(' ').trim() || 'Owner';
    const pct = p.ownerShipPCT != null ? p.ownerShipPCT : '';
    return pct !== '' ? `${name} (${pct}%)` : name;
  }

  getSplitOwnerHeadingForYtd(splitItem: any): string {
    const p = splitItem?.ownerProfileStmtSummery;
    if (!p) return '';
    const name = [p.firstName, p.middleName, p.lastName, p.suffix].filter(Boolean).join(' ').trim() || 'Owner';
    const pct = p.ownerShipPCT != null ? p.ownerShipPCT : '';
    return pct !== '' ? `${name} - ${pct}%` : name;
  }

  getValueByMonthForSplit(splitItem: any, month: string, field: string): number {
    const apis = splitItem?.yearlySummary?.stmtSummeryAPIs;
    if (!apis || !Array.isArray(apis)) return 0;
    const data = apis.find((stmt: any) => stmt.month && stmt.month.toUpperCase() === month);
    return data ? (data[field] ?? 0) : 0;
  }

  getSplitOwnerValue(splitItem: any, stmtSummeryField: string | null): number | null {
    if (!stmtSummeryField || !splitItem?.stmtSummery) return null;
    const val = splitItem.stmtSummery[stmtSummeryField];
    return val != null ? Number(val) : null;
  }

  getSummaryTotal(row: { totalKey: string }): number {
    const v = (this as any)[row.totalKey];
    return v != null ? Number(v) : 0;
  }

  sendStatementEmail(event: Event, statement: { ownerStmtId: number; propertyCode?: string; startDate?: any }) {
    event.stopPropagation();
    event.preventDefault();
    try {
      this.ownerStatementMailService.openStatementMailCompose(statement, {
        onLoading: (v) => this.mailComposeLoading = v,
        onPublishRequired: (summary, detail) => this.messageService.add({ severity: 'error', summary, detail, life: 5000 })
      });
    } catch (error) {
      console.error('Error preparing statement for email:', error);
      this.alertService?.error('Failed to prepare statement for email. Please try again.');
      this.mailComposeLoading = false;
    }
  }

  getExpenseCategoryName(expenseCategory: number): string {
    return this.expenseService.expenseCategories.find(category => category.value === expenseCategory)?.name || 'TBD';
  }


  openPropertyProfile(event: Event, propertyProfileId: number) {
    event.stopPropagation();
    event.preventDefault();
    if (propertyProfileId) {
      const url = this.router.serializeUrl(this.router.createUrlTree(['/property-profile/', propertyProfileId]));
      window.open(url, '_blank');
    }
  }
}
